export enum AlertBannerType {
  INVOICES_OVERDUE = 'INVOICES_OVERDUE',
  CART_UPDATED = 'CART_UPDATED',
  ABOVE_PAYMENT_TERM_LIMIT = 'ABOVE_PAYMENT_TERM_LIMIT',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PAYMENT_PLAN_INSTALMENT_FAILED = 'PAYMENT_PLAN_INSTALMENT_FAILED',
  LIMIT_INCREASED = 'LIMIT_INCREASED',
  IDV_REQUEST = 'IDV_REQUEST',
  MEMBERSHIP_PAYMENT_FAILED = 'MEMBERSHIP_PAYMENT_FAILED',
  CART_ITEM_WITH_INVALID_SCHEDULED_ORDER_DATE = 'CART_ITEM_WITH_INVALID_SCHEDULED_ORDER_DATE',
  INSTALLMENT_PLAN_DEFAULTED = 'INSTALLMENT_PLAN_DEFAULTED',
  M2M_REWARD_GRANTED = 'M2M_REWARD_GRANTED',
  PAYMENT_PLAN_COMPLETED = 'PAYMENT_PLAN_COMPLETED',
  CLOSE_TO_NET_LIMITS = 'CLOSE_TO_NET_LIMITS',
  POS_INTEGRATION_RELINK_REQUIRED = 'POS_INTEGRATION_RELINK_REQUIRED',
  RESOLVED_OVERDUE_INVOICES = 'RESOLVED_OVERDUE_INVOICES',
  RESELLER_CERTIFICATE_NUDGE = 'RESELLER_CERTIFICATE_NUDGE',
  PAYMENT_PLAN_LAPSE_RESOLVED = 'PAYMENT_PLAN_LAPSE_RESOLVED',
  /**
   * @deprecated
   */
  PLAID_ACH_RECOMMENDATION = 'PLAID_ACH_RECOMMENDATION',
  OPEN_WITH_FAIRE_APPLICATION_STARTED = 'OPEN_WITH_FAIRE_APPLICATION_STARTED',
  PLAID_ACH_RELINK_INSTRUMENT = 'PLAID_ACH_RELINK_INSTRUMENT',
  /**
   * @deprecated
   */
  NON_BM_TERMS_APPLICATION = 'NON_BM_TERMS_APPLICATION',
  /**
   * @deprecated
   */
  RETAILER_COUNTRY_BACKFILL = 'RETAILER_COUNTRY_BACKFILL',
  BACS_LINKING_FAILED = 'BACS_LINKING_FAILED',
  PAYMENT_ON_SHIPMENT_LIMIT_IMPOSED = 'PAYMENT_ON_SHIPMENT_LIMIT_IMPOSED',
  OPEN_WITH_FAIRE_IDV_REQUEST = 'OPEN_WITH_FAIRE_IDV_REQUEST',
  ORDERS_TO_REVIEW = 'ORDERS_TO_REVIEW',
  B2B_HOMEPAGE_GUIDE = 'B2B_HOMEPAGE_GUIDE',
  VAT_INVALID = 'VAT_INVALID',
  /**
   * @deprecated
   */
  POS_MARKETING_HOMEPAGE = 'POS_MARKETING_HOMEPAGE',
  NAM_EUR_SUBSIDIES_PULLBACK_ADVANCE_WARNING_BANNER = 'NAM_EUR_SUBSIDIES_PULLBACK_ADVANCE_WARNING_BANNER',
  INSIDER_BENEFITS_BANNER = 'INSIDER_BENEFITS_BANNER',
  CANADA_MISSING_TAX_REGISTRATION = 'CANADA_MISSING_TAX_REGISTRATION',
  UPFUNNEL_IDV_REQUEST = 'UPFUNNEL_IDV_REQUEST',
  PAYMENT_DISPUTE = 'PAYMENT_DISPUTE',
  SUBMITTED_IDV_REQUEST = 'SUBMITTED_IDV_REQUEST',
  R2B_SUSPENSION = 'R2B_SUSPENSION',
  FULL_NAM_EUR_SUBSIDIES_PULLBACK_ADVANCE_WARNING_BANNER = 'FULL_NAM_EUR_SUBSIDIES_PULLBACK_ADVANCE_WARNING_BANNER',
  FULL_NAM_EUR_SUBSIDIES_PULLBACK_BANNER = 'FULL_NAM_EUR_SUBSIDIES_PULLBACK_BANNER',
  BRAND_CART_REVIEW_REQUEST = 'BRAND_CART_REVIEW_REQUEST',
  /**
   * @deprecated
   */
  INSIDER_GROWTH_MEMBERSHIP_MIGRATION_BANNER = 'INSIDER_GROWTH_MEMBERSHIP_MIGRATION_BANNER',
  PROMPT_ADDING_PAYMENT_METHOD_TO_ACCEPT_RETAILER_OWNERSHIP = 'PROMPT_ADDING_PAYMENT_METHOD_TO_ACCEPT_RETAILER_OWNERSHIP',
  UW_REQUEST = 'UW_REQUEST',
  SUBMITTED_UW_REQUEST = 'SUBMITTED_UW_REQUEST',
  OPEN_WITH_FAIRE_UW_REQUEST = 'OPEN_WITH_FAIRE_UW_REQUEST',
  OVERDUE_INVOICE_PAYMENT_PROCESSING = 'OVERDUE_INVOICE_PAYMENT_PROCESSING',
  CARD_HAS_EXPIRED = 'CARD_HAS_EXPIRED',
  UW_REQUEST_SBO = 'UW_REQUEST_SBO',
  RETAILER_SUB_USER_IDV_REQUEST = 'RETAILER_SUB_USER_IDV_REQUEST',
  RETAILER_USER_ACCEPTED_INVITATION = 'RETAILER_USER_ACCEPTED_INVITATION',
  RETAILER_USER_INVITATION_EXPIRED = 'RETAILER_USER_INVITATION_EXPIRED',
  INSIDER_THRESHOLD_BANNER = 'INSIDER_THRESHOLD_BANNER',
  VIEW_MY_SHOP_COULD_BE_DELAYED = 'VIEW_MY_SHOP_COULD_BE_DELAYED',
  PENDING_SHIPPING_COST_ADJUSTMENT = 'PENDING_SHIPPING_COST_ADJUSTMENT',
  ADS_OUTSTANDING_BALANCE = 'ADS_OUTSTANDING_BALANCE',
  INSIDER_TERMS_AND_CONDITIONS_ACCEPTANCE_NUDGE = 'INSIDER_TERMS_AND_CONDITIONS_ACCEPTANCE_NUDGE',
  /**
   * @deprecated
   */
  FAIRE_PAY_DEFAULTED = 'FAIRE_PAY_DEFAULTED',
  TIN_LEGAL_NAME_MISMATCH = 'TIN_LEGAL_NAME_MISMATCH',
  DAC7_INTRODUCTORY_BANNER = 'DAC7_INTRODUCTORY_BANNER',
  DAC7_INVALID_BANNER = 'DAC7_INVALID_BANNER',
}
